//生产地址

//小满生产地址
//const GLOBAL_URL = {
//  // 文件下载地址前缀
//  upLoadFile: 'https://www.xmcdcn.com/pc',
//  serverUrl: 'https://ps.xmcdcn.com',
//  excelUpload: 'https://ps.xmcdcn.com/',
//  imageUrl: 'https://ps.xmcdcn.com'
//}
//dxq生产地址
 const GLOBAL_URL = {
   // 文件下载地址前缀
   upLoadFile: 'https://www.dianxiaoqu.com/pc',
   serverUrl: 'https://ps.dianxiaoqu.com',
   excelUpload: 'https://ps.dianxiaoqu.com/',
   imageUrl: 'https://ps.dianxiaoqu.com'
 }
//测试生产地址
//const GLOBAL_URL = {
//  // 文件下载地址前缀
//  upLoadFile: 'http://192.168.1.164:8080/ps',
//  serverUrl: 'http://192.168.1.164:8080/ps',
//  excelUpload: 'http://192.168.1.164:8080/ps',
//  imageUrl: 'https://ps.dianxiaoqu.com'
//}

const REQUEST_HEADER = {
  Authorization: 'zyyc_pc_mange_system'
}
const GLOBAL_STATES = {
  states: null
}

const DICT = {
  dict: sessionStorage.getItem("dict")
}

const USERINFO = {
  userInfo: sessionStorage.getItem("userInfo")
}

let set_user_info = function(data){
  sessionStorage.setItem("userInfo",JSON.stringify(data));
}

let set_dict = function( data ) {
  sessionStorage.setItem("dict",JSON.stringify(data))
}

let set_global_states = function(data){
  sessionStorage.setItem("global",JSON.stringify(data));
}
export {GLOBAL_URL,GLOBAL_STATES,DICT,set_global_states,set_user_info,set_dict,USERINFO,REQUEST_HEADER}



// WEBPACK FOOTER //
// ./src/config/config.js